import { bindRoutineToReduxForm, createRoutine } from 'redux-saga-routines';
import { LIST_HOLIDAY, UPDATE_HOLIDAY } from './types';

export const listHolidayHours = createRoutine(LIST_HOLIDAY);
// export const addHolidayHours = createRoutine(ADD_HOLIDAY);
export const updateHolidayHours = createRoutine(UPDATE_HOLIDAY);
export const bindedUpdateHolidayHours =
  bindRoutineToReduxForm(updateHolidayHours);
